import { ChallengeSettings } from "@/model/ChallengeSettings.model";
import { Game } from "@/model/Game.model";
import { Question } from "@/model/Question.model";
import { Observable } from "rxjs/internal/Observable";
import AjaxService from "./ajax.service";
import LayoutService from "./layout.service";
import { baseUrl } from "../config/firebase";
class GamesService extends AjaxService {
  getListGame(): Observable<Game[]> {
    LayoutService.setLoading(true);
    return new Observable(subscriber => {
      this.get(`${baseUrl}/createChallenge`).subscribe((result: any) => {
        const challengeSettings = result.response as ChallengeSettings[];
        const listGame = challengeSettings.map(g =>{
          const settingTimer = g.settings.find(s => s.name.toLowerCase() === "timer") as any;
          const game: Game = {
            id: g.id,
            name: g.challengeName || "",
            description: g.challengeDescription || "",
            length: settingTimer.data.totalTime,
            imageUrl: g.imageChallenge || '',
            genre: "",
            tag: "",
            creator: g.creator,
            type: g.name
          }
          return game;
        })
        subscriber.next(listGame);
        subscriber.complete();
        LayoutService.setLoading(false);
      })
    });
  }

  randomQuestion(data: any): Observable<Question[]> {
    LayoutService.setLoading(true);
    return new Observable(sub => {
      this.post(`${baseUrl}/randomQuestions`, JSON.stringify(data)).subscribe(result => {
       sub.next(result.response);
       sub.complete();
       LayoutService.setLoading(false);
      })
    })
  }
}

export default new GamesService();
